export const ROLES = {
    SUPER_ADMIN: 'super-admin',
    ADMIN: 'admin',
    APLICADOR: 'aplicador',
};